import './FilterContainer.css';

import React from 'react';

import { FilterCollapser } from '@search/vtbeco-frontend-core/domain/newbuilding/components/desktop/FilterCollapser';
import classname from '@search/classname/src';

import { FilterPanelProps, FilterPanel } from './FilterPanel/FilterPanel';

const cn = classname.bind(null, 'FilterContainer');

export function FilterContainer(props: FilterPanelProps & {
    handleReset: () => void;
    collapsed: boolean;
    toggleCollapsed: () => void;
}) {
    return (
        <div className={cn(null, { collapsed: props.collapsed })}>
            <FilterCollapser
                activeCount={props.filters.getCountActiveFilters()}
                collapsed={props.collapsed}
                // eslint-disable-next-line react/jsx-handler-names
                reset={props.handleReset}
                toggle={props.toggleCollapsed}
            />
            {props.collapsed ? null : <FilterPanel {...props} /> }
        </div>
    );
}
